import UltMeta, {Meta} from "./UltMeta/index";

export enum E_SHIP_AND_CARGO_TAB {
    SHIP = 1,
    CARGO = 2
}

class shipAndCargoTab extends UltMeta {
    SHIP = new Meta(E_SHIP_AND_CARGO_TAB.SHIP, "货找船");
    CARGO = new Meta(E_SHIP_AND_CARGO_TAB.CARGO, "船找货");
}
export const SHIP_AND_CARGO_TAB = new shipAndCargoTab();
